module.exports = __webpack_public_path__ + "static/media/undraw_group_selfie.dfbaff28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/undraw_group_selfie.svg
// module id = 15
// module chunks = 0